import { ReactNode, createContext, useContext, useMemo } from "react";
import { useMediaQuery } from "react-responsive";

interface IScreenSize {
  isSmallScreen: boolean;
  isSquishedScreen: boolean;
  useMobileSummaryScreen: boolean;
}

const ScreenSizeContext = createContext<IScreenSize>({
  isSmallScreen: false,
  isSquishedScreen: false,
  useMobileSummaryScreen: false
});

export const useScreenSize = () => {
  const context = useContext(ScreenSizeContext);
  if (!context) {
    throw new Error("useScreenSize must be used within a ScreenSize Provider!");
  }

  return context;
}

interface IScreenSizeProvider {
  children: ReactNode;
}

export function ScreenSizeProvider({ children }: IScreenSizeProvider) {
  const isSmallScreen = useMediaQuery({ query: '(max-width: 960px)' });
  const isSquishedScreen = useMediaQuery({ query: '(max-width: 955px),(max-height: 923px)' });
  const useMobileSummaryScreen = useMediaQuery({ query: '(max-width: 830px),(max-height: 670px)' });

  const values = useMemo(() => ({
    isSmallScreen,
    isSquishedScreen,
    useMobileSummaryScreen
  }), [isSmallScreen, isSquishedScreen, useMobileSummaryScreen]);

  return (<ScreenSizeContext.Provider value={values}>{children}</ScreenSizeContext.Provider>);
}
